import { HubJsonRpcRequest } from '../../../api/HubJsonRpcRequest';
import { HubApiMethods } from '../../../constants/HubApiMethods';
import { CustomJrpcErrResult } from '../jsonRpc/jRpcErrResponse';
import { container } from '../../../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../../../utils/container/service-ids';
import { FlagNames } from '../../../utils/feature-flags/flag-names';
import { getHubApi } from '../accountServiceApi/getAccountServiceApi';

export type ConfirmEmailOtpAuthRequest = {
    email: string,
    otp: string,
    locale: string
    current_entry_point: string
}

export type ConfirmEmailOtpAuthResponse = {
    tether: {
        suid: string;
        token: string;
    };
};

export function confirmEmailOtpAuth(data: ConfirmEmailOtpAuthRequest): Promise<ConfirmEmailOtpAuthResponse | CustomJrpcErrResult> {
    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();

    if (!isHubApiEnabled) {
        return HubJsonRpcRequest.makeRequest<ConfirmEmailOtpAuthResponse, ConfirmEmailOtpAuthRequest>(
            HubApiMethods.CONFIRM_EMAIL_OTP_AUTH,
            data,
            window.app.deviceIdentifier
        );
    } else {
        const hubApi = getHubApi();
        return hubApi.confirmEmailOtpAuth(window.app.deviceIdentifier, data) as Promise<ConfirmEmailOtpAuthResponse>;
    }
}
